<template>
  <div :class="navStyle">

    <div v-for="item in items"
         :key="item.id"
         :class="navItemStyle(item)" @click="[selected(item), $emit('navToggle')]">

      <i v-if="item.icon" :class="'smd-icon-' + item.icon"/>

      <p v-if="!compact && item.label">{{item.label}}</p>

      <div v-if="item.notif"
           class="smd-nav__notif" :class="item.notif.type">
        {{item.notif.text}}
      </div>

      <div v-if="hasError(item)"
           class="smd-nav__notif" :class="item.validationNotif">
      </div>

    </div>

    <template v-if="submenu">
      <smd-options custom :items="submenu"
                   @item-selected="selected"
                   :open-position="openPosition">
        <slot name="subheader"/>
      </smd-options>
    </template>

    <slot/>

  </div>
</template>

<script>
  export default {
    name: "smd-navigation",
    props:{
      compact      : {type: Boolean, default: false},
      items        : Array,
      submenu      : Array,
      type         : String,
      openPosition : {type: String, default: 'right'},
      itemValidationFlags: Object
    },
    data(){
      return{
        activeItem : null
      }
    },
    computed:{
      navStyle(){
        return [
          this.type    ? 'smd-nav--' + this.type : 'smd-nav',
          this.compact ? 'compact' : undefined
        ];
      }
    },
    methods:{
      hasError(item) {
        const t = (this.itemValidationFlags || {})[item.id];
        return t === false;
      },
      navItemStyle(item){

        if(this.activeItem != item && item.route && item.route == this.$route.name){
          this.activeItem = item;
        }

        return [
          item.id == 'spacer' ? 'smd-spacer' : 'smd-nav__item',
          this.activeItem == item  ? 'active' : undefined
        ]
      },
      selected(item){
        item.route ? this.$router.push({name: item.route}) : this.$emit('selected', item);
        this.activeItem = item;
      }
    }
  }
</script>

<style lang="scss">
  @import "scss/pogs-util";

  $root-block: 'smd-nav';
  $notif-alert-size: 14px;

  /*------------------------------------*\
      SMD-NAV Container Block
  \*------------------------------------*/

  .#{$root-block}{
    @extend %flex-col;

    height: 100%;

    &.primary{
      [class*='__item']{
        p{ font-size: font(s) !important; }
      }

      .#{$root-block}__item{
        @include space-me($prop: margin, $l: 3px, $r: 3px, $b: xs);
      }
    }
  }

  /*------------------------------------*\
    SMD-NAV Elements
  \*------------------------------------*/

  .#{$root-block}__item{
    @extend %user-no-select, %flex-row--center-x, %border-radius-small;
    @include space-me($t: s, $b: s, $l: s, $r: s);

    font-weight: font(medium-bold);

    color: color(dark);
    cursor: pointer;

    p{
      flex: 1;
    }

    .smd-profile-image + p{
      @include space-me($prop: margin, $l: xs);
    }

    [class^='smd-icon']{
      width: font(icon);

      &:before{
        color: color(label);
      }

      & + p{
        @include space-me($prop: margin, $l: s);
      }
    }

    .smd-icon-arrow-right{
      &:before{
        font-size: font(base);
      }
    }

    &.active,
    &:hover{
      background: color(hover);
    }

    &.disabled,
    &:disabled{
      cursor: default;

      p{
        color: color(disabled);
      }

      [class^='smd-icon'] {
        &:before {
          color: color(disabled);
        }
      }
    }
  }

  .compact{
    .#{$root-block}__item{
      position: relative;
    }

    .#{$root-block}__notif{
      position: absolute;
      top: 3px;
      right: 3px;
    }
  }

  .#{$root-block}__notif{

    &.alert{
      @extend %border-radius-circle, %flex-row--center-xy;

      background: color(red);
      color: white;
      font-size: 9px;
      font-weight: bold;

      height: $notif-alert-size;
      width: $notif-alert-size;
    }
  }

</style>
